// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Yub6","question":"styles_question__1kBS3","description":"styles_description__K232e"};